import React, { useRef, useState } from 'react';
import {
  DepartmentSelectorContainer,
  DepartmentSelectorOptions,
  DepartmentSelectorTitle,
  StatsIconContainer,
} from './DepartmentSelector.styled';
import { Checkbox } from '../../../common/sharedComponents/Checkbox';
import { Body4, Headline4 } from '../../../common/typography';
import { IDepartmentSelector } from '../../../@types/selfAssessment';
import { DropdownIcon } from '../../../common/icons/DropdownIcon';

export function DepartmentSelector ({ title, options }: IDepartmentSelector) {
  const content = useRef<HTMLDivElement>();
  const [isOpen, setOpen] = useState<boolean>(false);

  const checkedOptions = options.filter((option) => option.checked).length;
  const totalOptions = options.length - 1;
  const numberOfCheckedOptions =
    checkedOptions > totalOptions ? checkedOptions - 1 : checkedOptions;
  const isFullyChecked = checkedOptions - 1 === totalOptions;

  return (
    <DepartmentSelectorContainer>
      <DepartmentSelectorTitle onClick={() => setOpen(!isOpen)} isOpen={isOpen}>
        <Headline4>{title}</Headline4>
        <StatsIconContainer>
          <Body4>
            {isFullyChecked
              ? 'Full'
              : `${numberOfCheckedOptions}/${totalOptions} Selected`}
          </Body4>
          <DropdownIcon
            data-testid="expandable-card-dropdown-icon"
            rotate={isOpen ? '180' : '0'}
          />
        </StatsIconContainer>
      </DepartmentSelectorTitle>
      <DepartmentSelectorOptions ref={content} isOpen={isOpen}>
        {options &&
          options.map((option, index) => {
            return (
              <Checkbox
                key={option.label + index}
                label={option.label}
                onClick={option.optionCallback}
                checked={option.checked}
                disabled={option.disabled}
              />
            );
          })}
      </DepartmentSelectorOptions>
    </DepartmentSelectorContainer>
  );
}
